var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169.169,
    height: 125.912,
    viewBox: "0 0 44.759 33.314",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "rotateIcon_svg__a",
    refX: 0,
    refY: 0,
    orient: "auto-start-reverse",
    markerWidth: 6.135,
    markerHeight: 5.93,
    viewBox: "0 0 6.135 5.93",
    preserveAspectRatio: "xMidYMid",
    markerUnits: "userSpaceOnUse",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.7)",
    d: "M-.211-4.106L6.21-.894a1 1 90 010 1.788L-.21 4.106A1.236 1.236 31.717 01-2 3v-6A1.236 1.236 148.283 01-.211-4.106z",
    fill: "context-stroke",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "rotateIcon_svg__b",
    refX: 0,
    refY: 0,
    orient: "auto-start-reverse",
    markerWidth: 6.135,
    markerHeight: 5.93,
    viewBox: "0 0 6.135 5.93",
    preserveAspectRatio: "xMidYMid",
    markerUnits: "userSpaceOnUse",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.7)",
    d: "M-.211-4.106L6.21-.894a1 1 90 010 1.788L-.21 4.106A1.236 1.236 31.717 01-2 3v-6A1.236 1.236 148.283 01-.211-4.106z",
    fill: "context-stroke",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-63.357 -143.026)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.959,
    height: 27.026,
    x: 77.146,
    y: 146.305,
    ry: 0.237,
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    className: "rotateIcon_svg__UnoptimicedTransforms",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.15 162.194v5.923h7.742m-7.743-10.97v-5.922h7.743M83.383 168.095h6.721m-6.721-16.848h6.721M94.74 168.048h4.51v-5.902m-4.51-10.852h4.51v5.902"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.84 -.027)",
    d: "M100.65 146.162a16.884 16.884 0 01-.008 27.1m-28.137-27.1a16.883 16.883 0 00.008 27.1",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    markerStart: "url(#rotateIcon_svg__a)",
    markerEnd: "url(#rotateIcon_svg__b)"
  }))));
}
export default SvgRotateIcon;